/**
 * @fileoverview added by tsickle
 * Generated from: util/promise-utils.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * A simple utility which returns a timeout promise for async delays
 * @param {?} ms
 * @return {?}
 */
export function sleep(ms) {
    return new Promise((/**
     * @param {?} resolve
     * @return {?}
     */
    function (resolve) { return setTimeout(resolve, ms); }));
}
